import { createContext, use } from "react";

interface TimelineContextValue {
	refetch: () => Promise<void>;
}

export const TimelineContext = createContext<TimelineContextValue>({
	refetch: async () => {},
});

export function useTimelineContext() {
	return use(TimelineContext);
}
